/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { FC } from 'react'
import { isDefined } from '../../../../types.helper'
import PerText from '../../../../components/custom_components/Text'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import { Col, Divider } from 'antd'
import { PerCardWithAvatar } from '../../../../components/custom_components/CardWithAvatar'
import { FullMeetingFragment } from '../../../../types'
import { useTranslation } from 'react-i18next'
import RichTextBox from '../../../../components/custom_components/RichTextBox'

type Props = {
  meeting: FullMeetingFragment
}

const GeneralFeedback: FC<Props> = ({ meeting }) => {
  const [t] = useTranslation()

  if (
    !!meeting.appraisal &&
    !!meeting.reviewer &&
    ((isDefined(meeting.appraisal.employeeGeneralFeedback) && meeting.employeePrepared) ||
      isDefined(meeting.appraisal.reviewerGeneralFeedback))
  ) {
    return (
      <>
        <Divider />
        <PerText appearance="tile-heading" mt="l" mb="m">
          {t('appraisalMeeting.stepOverview.feedbackHeadlineManager')}
        </PerText>
        <PerFlexRow>
          {isDefined(meeting.appraisal.employeeGeneralFeedback) && meeting.employeePrepared && (
            <Col span={12}>
              <PerCardWithAvatar
                nameType="firstName"
                employeeId={meeting.employee.id}
                firstName={meeting.employee.chosenFirstName ? meeting.employee.chosenFirstName : meeting.employee.legalFirstName}
                lastName={meeting.employee.chosenLastName ? meeting.employee.chosenLastName : meeting.employee.legalLastName}
              >
                <RichTextBox text={meeting.appraisal.employeeGeneralFeedback!} readonly />
              </PerCardWithAvatar>
            </Col>
          )}
          {isDefined(meeting.appraisal.reviewerGeneralFeedback) && (
            <Col span={12}>
              <PerCardWithAvatar
                nameType="you"
                employeeId={meeting.reviewer.id}
                firstName={meeting.reviewer.firstName}
                lastName={meeting.reviewer.lastName}
              >
                <RichTextBox text={meeting.appraisal.reviewerGeneralFeedback!} readonly />
              </PerCardWithAvatar>
            </Col>
          )}
        </PerFlexRow>
      </>
    )
  }

  return <></>
}

export default GeneralFeedback
